import editEn from './edit/en.json';
import editZhHant from './edit/zh-Hant.json';
import editVi from './edit/vi.json';
import editTh from './edit/th.json';

export default {
  en: editEn,
  'zh-Hant': editZhHant,
  vi: editVi,
  th: editTh,
};
